import { BaseComponent } from '../../base-component';
import { trackOnNextPageImpression } from '@otto-ec/tracking-bct';
import { event } from '@otto-ec/global-resources/event';

export class ExploreBrandComponent extends BaseComponent {
    public rootSelector = '.js_pdp_explore-brand';

    public async onHtmlLoaded(): Promise<undefined> {
        if (!this.isPresent()) return;
        if (!!this.getRootElement().querySelector('.js_pdp_explore-brand__brand-link')) {
            event.delegate(this.getRootElement(), 'click', '.js_pdp_explore-brand__brand-link', () => {
                const brandName = this.getRootElement().dataset.brandName;
                if (brandName) {
                    trackOnNextPageImpression({ 'wk.product_BrandLogoClicked': [brandName] });
                }
            });
        }
    }
}
